/* ===========================================================
   LureGuessr — product variant picker
   Matches selected option values to a variant, then updates
   price, availability, the add button, hidden id, and image.
   =========================================================== */
(function () {
  'use strict';

  // Common bait-color name → hex, for the round swatches.
  var SWATCH_COLORS = {
    'watermelon red flake': '#8B1A1A',
    'watermelon red': '#8B1A1A',
    'electric shad': '#4a90d9',
    'pumpkin chartreuse': '#c97c2e',
    'chartreuse pearl': '#9ACD00',
    'black blue flake': '#2a2a2a',
    'natural shad': '#c0a060',
    'green pumpkin': '#5a6a30',
    'junebug': '#2d1b4e',
    'smoke': '#9aa0a6'
  };

  document.querySelectorAll('[data-product-section]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var availBadge = root.querySelector('[data-availability]');
    var availText = root.querySelector('[data-availability-text]');
    var addBtn = root.querySelector('[data-add-button]');
    var mainImg = root.querySelector('[data-gallery-main]');
    var qtyInput = root.querySelector('.qty-input');
    var shippingAlert = root.querySelector('[data-shipping-alert]');
    var shippingMessage = root.querySelector('[data-shipping-message]');
    var shippingFill = root.querySelector('[data-shipping-fill]');

    // Full-screen image lightbox — click the product image to see it large.
    var lightboxTrigger = root.querySelector('[data-lightbox-trigger]');
    var lightbox = document.querySelector('[data-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
    var lightboxClose = lightbox ? lightbox.querySelector('[data-lightbox-close]') : null;

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    if (lightboxTrigger && mainImg && lightbox && lightboxImg) {
      lightboxTrigger.style.cursor = 'zoom-in';
      lightboxTrigger.addEventListener('click', function () {
        lightboxImg.src = mainImg.src.replace(/width=\d+/, 'width=1600');
        lightboxImg.alt = mainImg.alt || '';
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    }

    function updateShipping(variant) {
      if (!shippingAlert || !shippingMessage || !variant) return;
      var threshold = parseInt(shippingAlert.getAttribute('data-threshold'), 10) || 0;
      var cartTotal = parseInt(shippingAlert.getAttribute('data-cart-total'), 10) || 0;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var projected = cartTotal + variant.price * qty;
      var remaining = threshold - projected;
      if (shippingFill && threshold > 0) {
        shippingFill.style.width = Math.min(100, (projected / threshold) * 100) + '%';
      }
      shippingAlert.classList.toggle('shipping-alert--met', remaining <= 0);
      if (remaining > 0) {
        shippingMessage.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more to qualify. Ships within 2–3 business days.';
      } else {
        shippingMessage.textContent = 'You qualify for free shipping! Ships within 2–3 business days.';
      }
    }

    // Paint swatch colors.
    root.querySelectorAll('[data-swatch]').forEach(function (sw) {
      var key = sw.getAttribute('data-swatch').toLowerCase();
      sw.style.background = SWATCH_COLORS[key] || '#888';
    });

    // Track the currently selected value per option position (1-based).
    var selected = {};
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var display = group.querySelector('[data-option-display]');
      var active = group.querySelector('.active[data-value], [data-option-value].active');
      if (active) selected[active.getAttribute('data-option-value')] = active.getAttribute('data-value');
    });

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (pos) {
          return v.options[parseInt(pos, 10) - 1] === selected[pos];
        });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (availText) availText.textContent = v.available ? 'In Stock' : 'Sold Out';
      if (availBadge) {
        availBadge.classList.toggle('stock-badge--in', v.available);
        availBadge.classList.toggle('stock-badge--out', !v.available);
      }
      if (addBtn) {
        addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
        addBtn.disabled = !v.available;
        addBtn.classList.toggle('is-disabled', !v.available);
      }
      updateShipping(v);
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.style.opacity = '0';
        setTimeout(function () { mainImg.src = v.featured_image.src; mainImg.style.opacity = '1'; }, 150);
      }
    }

    function choose(pos, value, group) {
      selected[pos] = value;
      if (group) {
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          var on = b.getAttribute('data-value') === value;
          b.classList.toggle('active', on);
          if (b.classList.contains('bs-btn')) {
            b.classList.toggle('bs-btn-dark', on);
            b.classList.toggle('bs-btn-ghost', !on);
          }
        });
        var display = group.querySelector('[data-option-display]');
        if (display) {
          // Count options render as "100 Baits"; the suffix lives on the
          // element so re-rendering here does not strip it.
          display.textContent = value + (display.getAttribute('data-option-suffix') || '');
        }
        var fallback = group.querySelector('[data-option-fallback]');
        if (fallback) fallback.value = value;
      }
      update();
    }

    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.querySelectorAll('button[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          choose(btn.getAttribute('data-option-value'), btn.getAttribute('data-value'), group);
        });
      });
      var fallback = group.querySelector('[data-option-fallback]');
      if (fallback) {
        fallback.addEventListener('change', function () {
          choose(fallback.getAttribute('data-option-fallback'), fallback.value, group);
        });
      }
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        updateShipping(findVariant());
      });
      qtyInput.addEventListener('input', function () {
        updateShipping(findVariant());
      });
    }

    // AJAX add-to-cart — stays on the page and shows a Continue Shopping / View
    // Cart confirmation instead of redirecting away (so we don't lose an upsell).
    var form = root.querySelector('form');
    var cartConfirm = root.querySelector('[data-cart-confirm]');
    var cartConfirmText = root.querySelector('[data-cart-confirm-text]');

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;

        var originalLabel = addBtn ? addBtn.textContent : '';
        if (addBtn) {
          addBtn.textContent = 'Adding…';
          addBtn.disabled = true;
        }
        if (cartConfirm) {
          cartConfirm.hidden = true;
          cartConfirm.classList.remove('cart-confirm--error');
        }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error((result.data && result.data.description) || 'Could not add that to your cart.');
            }
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
            if (shippingAlert) {
              shippingAlert.setAttribute('data-cart-total', cart.total_price);
              updateShipping(findVariant());
            }
            if (cartConfirm) {
              if (cartConfirmText) cartConfirmText.textContent = 'Added to cart!';
              cartConfirm.hidden = false;
            }
          })
          .catch(function (err) {
            if (cartConfirm) {
              if (cartConfirmText) cartConfirmText.textContent = err.message || 'Something went wrong — please try again.';
              cartConfirm.classList.add('cart-confirm--error');
              cartConfirm.hidden = false;
            }
          })
          .finally(function () {
            if (addBtn) {
              addBtn.textContent = originalLabel;
              addBtn.disabled = false;
            }
          });
      });
    }

    if (cartConfirm) {
      var dismissBtn = cartConfirm.querySelector('[data-cart-confirm-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
          cartConfirm.hidden = true;
        });
      }
    }
  });
})();
